/**
 * `ModuleName` enum values are all lower-case.
 */
export enum ModuleName {
  Cocaine = 'cocaine',
  Xanax = 'xanax',
  Mdma = 'mdma',
  Response = 'response',
  Lightning = 'lightning'
}

export enum ModuleNamePerceptionBar {
  Cocaine = 'Cocaine',
  Xanax = 'Xanax',
  Mdma = 'MDMA',
  Response = 'Fentanyl',
  Lightning = 'Lightning Round'
}

export enum ModuleNameScreenReader {
  Cocaine = 'Cocaine',
  Xanax = 'Xanax',
  Mdma = 'M D M A',
  Response = 'Overdose Response',
  Lightning = 'Lightning Round'
}

export enum StatusValue {
  INPROGRESS = 'in progress',
  COMPLETED = 'completed',
  PENDING = 'pending',
}

export enum MetadataType {
  QuestionVideoTimestamp = 'video_question_timestamp',
  QuestionMcqPart = 'question_mcq_part'
}

export enum QuestionType {
  Video = 'video',
  Mcq = 'mcq'
}

export enum HTTP_STATUS {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500
};
